'use client';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useRef, useContext } from 'react';
import { ModalContext } from './ModalContext';
import { styled } from 'styled-components';
import { breakpoints, colors, dontForwardProps, useOverflow } from '@soluto-private/mx-asurion-ui-react';
const getStickyTopBorder = ({
  isOverflow,
  hasHeader,
  isHeroHeader
}) => {
  if (isOverflow && hasHeader && !isHeroHeader) {
    return `
    border-top: 0.0625rem solid ${colors.neutralBright};
    margin-top: 1rem; 
    ${breakpoints.md} { 
      margin-top: 1.5rem 
    }`;
  }
  return '';
};
const getStickyBottomBorder = ({
  isOverflow,
  hasFooter
}) => {
  if (isOverflow && hasFooter) {
    return `
    border-bottom: 0.0625rem solid ${colors.neutralBright};
    margin-bottom: 1rem; 
    ${breakpoints.md} { 
      margin-bottom: 1.5rem 
    }`;
  }
  return '';
};
const ModalContent = styled.div.withConfig(dontForwardProps()).withConfig({
  componentId: "aui__sc-xh9tmi-0"
})(["flex:1;padding:1rem;overflow:", ";", "{padding:1.5rem;}", " ", ""], ({
  isSticky
}) => isSticky ? 'auto' : 'visible', breakpoints.md, getStickyTopBorder, getStickyBottomBorder);
export const Content = ({
  children,
  ...rest
}) => {
  const ref = useRef();
  const modalContext = useContext(ModalContext);
  const isOverflow = useOverflow(ref);
  return /*#__PURE__*/React.createElement(ModalContent, _extends({
    isOverflow: isOverflow,
    ref: ref
  }, rest, modalContext), children);
};